import React, { ChangeEvent, useState } from 'react';

import useCreateNewRoomDataContext from 'modules/CreateNewRoomModal/CreateNewRoomDataProvider/useCreateNewRoomDataContext';

const useParticipantsField = () => {
  const { roomForm } = useCreateNewRoomDataContext();
  const [shouldDisplayError, setShouldDisplayError] = useState(false);

  const {
    getValues,
    watch,
    setValue,
    formState: { errors },
  } = roomForm;

  const participantsWatch = watch('participants');

  const removeParticipant = (email: string) =>
    setValue(
      'participants',
      participantsWatch.filter((participant) => email !== participant)
    );

  const addParticipant = () => {
    const participantInput = getValues('participantInput');
    const isExistingParticipant = participantsWatch.some((participant) => participant === participantInput);

    if (!participantInput || isExistingParticipant || errors.participantInput?.message) {
      return setShouldDisplayError(true);
    }

    setValue('participants', [participantInput.trim().toLowerCase(), ...participantsWatch]);
    setValue('participantInput', '');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const keys = [',', ' ', 'Enter'];
    if (!keys.includes(e.key)) return;

    e.preventDefault();
    addParticipant();
  };

  const handleChange =
    (onChange: (value: string) => void) =>
    ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
      if (shouldDisplayError && !errors.participantInput?.message) setShouldDisplayError(false);
      onChange(value);
    };

  return { shouldDisplayError, handleKeyDown, handleChange, removeParticipant, addParticipant };
};

export default useParticipantsField;
